(() => {
  if (window.dolceCardDesign2Ready) return;
  window.dolceCardDesign2Ready = true;
  const selector = '[data-dolce-card]';
  const setOpen = (card, open) => {
    card.classList.toggle('is-open', open);
    const toggle = card.querySelector('.dolce-card__toggle');
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(open));
    }
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.dolce-card__toggle');
    document.querySelectorAll(`${selector}.is-open`).forEach((card) => {
      if (!card.contains(event.target)) setOpen(card, false);
    });
    if (!toggle || !toggle.form) return;
    const card = toggle.closest(selector);
    const form = toggle.form;
    if (form.querySelector('[name="id"][type="radio"]') && !form.querySelector('[name="id"]:checked')) {
      event.preventDefault();
      setOpen(card, true);
      form.querySelector('.dolce-card__status').textContent = toggle.dataset.chooseLabel;
      form.querySelector('[name="id"]').focus();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const card = event.target.closest(selector);
    if (!card) return;
    setOpen(card, false);
    card.querySelector('.dolce-card__toggle')?.focus();
  });
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.dolce-card__size input');
    if (!input) return;
    const form = input.closest('form');
    form.elements.quantity.value = input.dataset.quantity;
    const price = form.closest(selector).querySelector('[data-dolce-price]');
    if (price) {
      const amount = document.createElement('span');
      amount.className = 't4s-product-price';
      amount.textContent = input.dataset.price;
      price.replaceChildren(amount);
    }
    form.querySelector('.dolce-card__status').textContent = '';
    form.querySelector('.dolce-card__cart-link').hidden = true;
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.dolce-card__form');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const card = form.closest(selector);
    const submit = card.querySelector('button.dolce-card__toggle');
    const status = form.querySelector('.dolce-card__status');
    const cartLink = form.querySelector('.dolce-card__cart-link');
    form.dataset.busy = 'true';
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    submit.setAttribute('aria-label', submit.dataset.addingLabel);
    submit.classList.add('is-adding');
    status.textContent = '';
    status.classList.remove('is-error');
    cartLink.hidden = true;
    try {
      const data = new FormData(form);
      const endpoint = new URL(form.action, window.location.origin);
      endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
      const response = await fetch(endpoint, {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
      setOpen(card, true);
      status.textContent = status.dataset.success;
      cartLink.hidden = false;
      document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
    } catch (error) {
      setOpen(card, true);
      status.classList.add('is-error');
      status.textContent = error instanceof Error && error.message !== 'Failed to fetch' ? error.message : status.dataset.error;
    } finally {
      form.dataset.busy = 'false';
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      submit.setAttribute('aria-label', submit.dataset.addLabel);
      submit.classList.remove('is-adding');
    }
  });
  const syncWishlist = (button) => {
    const added = button.classList.contains('is--added');
    button.setAttribute('aria-pressed', String(added));
    button.setAttribute('aria-label', added ? button.dataset.labelRemove : button.dataset.labelAdd);
  };
  const observeWishlist = (root) => {
    root.querySelectorAll('.dolce-card__wishlist:not([data-dolce-observed])').forEach((button) => {
      button.dataset.dolceObserved = 'true';
      syncWishlist(button);
      new MutationObserver(() => syncWishlist(button)).observe(button, { attributes: true, attributeFilter: ['class'] });
    });
  };
  observeWishlist(document);
  new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) observeWishlist(node);
    }
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
})();
